import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { Families } from 'src/pages/Families';
import { Simulator } from 'src/pages/Simulator';
import { NotFound } from 'src/pages/NotFound';
import { Sidebar } from 'src/components/system/Sidebar';
import { Login } from 'src/pages/Auth/Login';
import { Register } from 'src/pages/Auth/Register';
import { ForgotPassword } from 'src/pages/Auth/ForgotPassword';
import { ResetPassword } from 'src/pages/Auth/ResetPassword';
import { ChangePassword } from 'src/pages/Auth/ChangePassword';
import { RequireAuth } from './RequireAuth';
import { RequireAdmin } from './RequireAdmin';
import { Results } from 'src/pages/Results';
import { History } from 'src/pages/History';
import { QuickGame } from 'src/pages/QuickGame';
import { Profile } from 'src/pages/Profile';
import { Home } from 'src/pages/Home';
import { Admin } from 'src/pages/Admin';
import { useCourseCategories } from 'src/contexts/CourseCategoriesContext';

export function AppRouter() {
  const location = useLocation();
  const isAuthRoute = location.pathname.startsWith('/auth');
  const { categories } = useCourseCategories();
  const defaultFamilySlug = categories[0]?.slug ?? 'cfp';

  if (isAuthRoute) {
    return (
      <Routes>
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/register" element={<Register />} />
        <Route path="/auth/forgot-password" element={<ForgotPassword />} />
        <Route path="/auth/reset-password" element={<ResetPassword />} />
        <Route path="/auth/change-password" element={<ChangePassword />} />
        <Route path="*" element={<Navigate to="/auth/login" replace />} />
      </Routes>
    );
  }

  return (
    <Sidebar>
      <Routes>
        <Route
          path="/home"
          element={
            <RequireAuth>
              <Home />
            </RequireAuth>
          }
        />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Navigate to={`/families/${defaultFamilySlug}`} replace />
            </RequireAuth>
          }
        />
        <Route
          path="/families"
          element={
            <RequireAuth>
              <Navigate to={`/families/${defaultFamilySlug}`} replace />
            </RequireAuth>
          }
        />
        <Route
          path="/families/:slug"
          element={
            <RequireAuth>
              <Families />
            </RequireAuth>
          }
        />
        <Route
          path="/simulate/:sessionId"
          element={
            <RequireAuth>
              <Simulator />
            </RequireAuth>
          }
        />
        <Route
          path="/results/:id"
          element={
            <RequireAuth>
              <Results />
            </RequireAuth>
          }
        />
        <Route
          path="/quick-game"
          element={
            <RequireAuth>
              <QuickGame />
            </RequireAuth>
          }
        />
        <Route
          path="/profile"
          element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          }
        />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <Admin />
            </RequireAdmin>
          }
        />
        <Route
          path="/history"
          element={
            <RequireAuth>
              <History />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Sidebar>
  );
}
